import { createContext, useContext } from 'react';

/** `ProductContentFrame` 이 카드로 그릴 때 true 를 내려준다. 카드 스크롤·복원 코드를 끌어오지 않게 따로 둔다. */
export const ProductContentFrameContext = createContext(false);

/** 카드 안에 그려지는지. 카드 밖(외부 플랫폼·카드를 쓰지 않는 화면)에서는 false. 하위 레이아웃이 카드용 배치를 고른다. */
export const useIsInProductContentFrame = () =>
  useContext(ProductContentFrameContext);
